// extracted by mini-css-extract-plugin
export var chip = "_ep-0";
export var filterDropdown = "_ep-5";
export var filterItem = "_ep-6";
export var icon = "_ep-1";
export var removeButton = "_ep-3";
export var removeIcon = "_ep-4";
export var separator = "_ep-2";